import React,{useState} from 'react';

type Props = {};

const DomianBlacklistPage = (props: Props) => {
  const [domains, setDomains] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDomains(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Blacklisted Domains:', domains);
    alert('Blacklisted Domains Updated!');
  };

  const containerStyle = {
    maxWidth: '100%',
    margin: '0 auto',
    boxShadow: '6px 4px 10px 5px rgba(0, 0, 0, 0.2)',
    padding: '20px 0px',
    borderRadius: '0px',
    height: '80%',
  };

  const textAreaStyle = {
    width: '100%',
    padding: '10px',
    marginBottom: '15px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '12px',
    backgroundColor: '#F5F5F5',
    minHeight: '150px',
    resize: 'none' as const,
  };

  const buttonStyle = {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '4px',
    backgroundColor: '#1173B7',
    color: 'white',
    cursor: 'pointer',
    fontSize: '12px',
    width: '20%',
    marginTop: '10px',
  };

  const titleStyle = {
    fontSize: '14px',
    marginBottom: '20px',
    textAlign: 'left' as const,
  };

  const descriptionStyle = {
    fontSize: '12px',
    marginBottom: '15px',
  };

  const exampleStyle = {
    fontSize: '12px',
    fontWeight: 'bold' as const,
    marginBottom: '10px',
  };

  const noteStyle = {
    fontSize: '10px',
    marginTop: '10px',
    color: 'gray',
  };

  return (
    <div style={containerStyle}>
      <div style={{ width: '80%', textAlign: 'left', margin: '0 30px' }}>
        <h2 style={titleStyle}>Edit Your Blacklisted Domains:</h2>
        <p style={descriptionStyle}>
          You have the optional possibility to blacklist domain names for all
          your campaigns. You will not receive any traffic from these domains.
        </p>
        <p style={descriptionStyle}>
          Please note that there are cases where we are not able to get the
          referrer from our publishers in real-time. You can add the following
          dummy domain to your list to block your ads from showing when there is
          no referrer passed: <strong>noreferrer.com</strong>
        </p>
        <p style={descriptionStyle}>
          (Please be aware though that this may significantly decrease your
          traffic)
        </p>
        <p style={exampleStyle}>Examples:</p>
        <ul style={{ fontSize: '12px', marginBottom: '15px' }}>
          <li>cnn.com</li>
          <li>espn.com</li>
          <li>bbc.co.uk</li>
        </ul>
        <form onSubmit={handleSubmit}>
          <textarea
            value={domains}
            onChange={handleInputChange}
            placeholder="Enter domains, one per line"
            style={textAreaStyle}
          />
          <p style={noteStyle}>Maximum of 1000 Entries</p>
          <button type="submit" style={buttonStyle}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default DomianBlacklistPage;